module.exports = __webpack_public_path__ + "static/43invgde-71a361926e9386c00cfe7cc909e53fe1.gif";